/* eslint-disable */
import { onMounted } from 'vue';
export const EUDC = (needEUDC = true) => {
    onMounted(() => {
        if (needEUDC) {
            if ('function' === typeof (parseEUDC)) {
                parseEUDC('ap');
            }
        }
    });
};